export default __webpack_public_path__ + "static/media/paperwork.014e649c.jpg";